// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"1836acd3","828":"eca38142"}[chunkId] + ".chunk.js";
};